export default __webpack_public_path__ + "static/team2-cdde950d8f3dc7ab077cb94ffd21b3a2.jpg";